import API from "@/API";

const SET_ACCOUNT_ID = "SET_ACCOUNT_ID";
const SET_PHONES = "SET_PHONES";

const state = {
  phones: [],
  accountId: ""
};

const actions = {
  setPhones({ commit }, phones) {
    commit("SET_PHONES", phones);
  },
  setAccountId({ commit }, accountId) {
    commit("SET_ACCOUNT_ID", accountId);
  },
  async listAccountPhones({ state, dispatch }) {
    try {
      const response = await API.Phones.getAccountPhones(state.accountId);

      dispatch("setPhones", response);
    } catch (e) {
      throw "Não foi possivel listar os telefones da conta!";
    }
  },
  async createPhone({}, { data, accountId }) {
    try {
      return await API.Phones.create(data, accountId);
    } catch (e) {
      throw "Não foi possivel criar o profissional!";
    }
  },

  async showPhone({}, phoneId) {
    try {
      return await API.Phones.show(phoneId);
    } catch (e) {
      throw "Não foi possivel encontrar o telefone!";
    }
  },

  async deletePhone({}, phoneId) {
    try {
      return await API.Phones.delete(phoneId);
    } catch (e) {
      throw "Não foi possivel deleter o telefone!";
    }
  },

  async updatePhone({}, { data, phoneId }) {
    try {
      return await API.Phones.update(data, phoneId);
    } catch (e) {
      throw "Não foi possivel alterar o telefone!";
    }
  }
};

const mutations = {
  [SET_ACCOUNT_ID](state, accountId) {
    state.accountId = accountId;
  },
  [SET_PHONES](state, phones) {
    state.phones = phones;
  }
};

export default {
  namespaced: true,
  actions: {
    ...actions
  },
  mutations: {
    ...mutations
  },
  state: {
    ...state
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/account/phones.js